(function() {
  'use strict';

  function DocumentDialogCtrl ($mdDialog) {
    var ctrl = this;
    ctrl.close = function () {
      $mdDialog.cancel();
    };
    ctrl.formSubmit = function (form) {
      $mdDialog.hide({
        document: form.hasDocument.$modelValue ? 'NFe' : null,
      });
    };
  }

  angular
    .module('mandaeApp')
    .controller('DocumentDialogCtrl', DocumentDialogCtrl);

}());
